import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import { Ripple, Scroll } from 'vuetify/lib/directives'

Vue.use(Vuetify, {
  directives: {
    Ripple,
    Scroll,
  },
})

export default new Vuetify({
  icons: {
    iconfont: 'mdi',
  },
})
